import React from 'react'
import './style.scss'
import { Routes, Route } from 'react-router-dom'
import NavBar from '../../components/NavBar/Matches'

import NewMatches from './New/Index'
import TodayMatches from './Today/Index'
import AllMatches from './All/Index'
import NearMe from './NearMe/Index'
import RecentlyViewed from './RecentlyViewed/Index'
// import FourOFour from '../FourOfour/Index'

const Master = () => {

    return (
        <div className="matches-master">
            <NavBar />
            <Routes>

                    <Route path="/" element={<NewMatches />} />
                    <Route path="today" element={<TodayMatches />} />
                    <Route path="all" element={<AllMatches />} />
                    <Route path="near-me" element={<NearMe />} />
                    <Route path="recently-viewed" element={<RecentlyViewed />} />

                    {/* <Route path="*" element={<FourOFour />} /> */}

            </Routes>
        </div>
    );
};

export default Master;